import { FetchData, UserManager } from '../../cloneme-classes';
import { handleFormSubmit } from '../../utils';
import type { UserInfo } from '../../cloneme-classes/FetchDataTypes';

export class Profile {
  private userManager: UserManager | undefined;

  public async init(): Promise<void> {
    this.userManager = await UserManager.getInstance();
    this.listenForPaymentSuccess();
    this.initializePersonalInfoSection();
    this.initializeBillingSection();
    this.initializePrivateSection();
  }

  /**
   * EcSuitePurchasePopup dispatches `ecsuite:payment-success` after a
   * successful charge. The wallet counter on /profile is rendered from
   * `/api/me/wallet` at page load and doesn't observe wallet state after
   * mount, so users would otherwise see their old balance until a manual
   * reload. Slight delay lets the popup show its success message first.
   */
  private listenForPaymentSuccess(): void {
    window.addEventListener('ecsuite:payment-success', () => {
      setTimeout(() => window.location.reload(), 2500);
    });
  }

  private initializePersonalInfoSection(): void {
    const nameField: HTMLInputElement = document.querySelector(
        '[data-name=firstName]'
    ) as HTMLInputElement;
    const lastNameField: HTMLInputElement = document.querySelector(
        '[data-name=lastName]'
    ) as HTMLInputElement;
    const emailField: HTMLInputElement = document.querySelector(
        '[data-name=Email]'
    ) as HTMLInputElement;
    const mobileField: HTMLInputElement = document.querySelector(
        '[data-name=mobileNumber]'
    ) as HTMLInputElement;

    if (nameField) nameField.value = this.userManager.firstName ?? '';
    if (lastNameField) lastNameField.value = this.userManager.lastName ?? '';
    if (emailField) emailField.value = this.userManager.email ?? '';
    if (mobileField) mobileField.value = this.userManager.phone ?? '';

    const form: HTMLFormElement = document.getElementById('email-form') as HTMLFormElement;
    handleFormSubmit(form, function(): Promise<boolean> {
      const formData = new FormData(form);
      // Example: Log form data to the console

      const userInfo: UserInfo = {
        firstName: '',
        lastName: '',
        mobileNumber: '',
      };

      formData.forEach((value, key: string):void => {
        if (userInfo.hasOwnProperty(key)) {
          // @ts-ignore
          userInfo[key] = value;
        }
      });
      return FetchData.updateUserProfile(userInfo)
          .then((data):boolean => {
            console.log(data);
            return true;
          })
          .catch((error):boolean => {
            console.warn(error);
            return false;
          });
    });
  }

  private initializeBillingSection(): void {
    const subscriptionPlan: HTMLElement = document.getElementById(
      'subscription-plan'
    ) as HTMLElement;
    const subscriptionPlanExpirationDate: HTMLElement = document.getElementById(
      'subscription-expiration-date'
    ) as HTMLElement;
    const availableTokens: HTMLElement = document.getElementById('available-tokens') as HTMLElement;
    const tokensExpirationDate: HTMLElement = document.getElementById(
      'tokens-expiration-date'
    ) as HTMLElement;
    const availableKeys: HTMLElement = document.getElementById('available-keys') as HTMLElement;
    const keysExpirationDate: HTMLElement = document.getElementById(
      'keys-expiration-date'
    ) as HTMLElement;
    if (availableTokens)
      availableTokens.textContent = `${this?.userManager?.wallet?.tokensInfo?.number ?? 0} tokens`;
    if (availableKeys)
      availableKeys.textContent = `${this?.userManager?.wallet?.keysInfo?.number ?? 0} keys`;
    if (subscriptionPlan)
      subscriptionPlan.textContent =
        this?.userManager?.wallet?.subscription?.name || 'Free Trial / No Plan';

    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    if (
      subscriptionPlanExpirationDate &&
      this?.userManager?.wallet?.subscription?.validUntil
    ) {
      const dateAux: Date = new Date(this?.userManager?.wallet?.subscription?.validUntil);
      subscriptionPlanExpirationDate.textContent = `Expires on ${dateAux.toLocaleDateString(
        'en-US',
        options
      )}`;
    } else if (subscriptionPlanExpirationDate) subscriptionPlanExpirationDate.textContent = '';

    if (tokensExpirationDate && this?.userManager?.wallet?.tokensInfo?.validUntil) {
      const dateAux: Date = new Date(this.userManager.wallet.tokensInfo.validUntil);
      tokensExpirationDate.textContent = `Expires on ${dateAux.toLocaleDateString(
        'en-US',
        options
      )}`;
    } else if (tokensExpirationDate) tokensExpirationDate.textContent = '';

    if (keysExpirationDate && this?.userManager?.wallet?.keysInfo?.validUntil) {
      const dateAux: Date = new Date(this.userManager.wallet.keysInfo?.validUntil);
      keysExpirationDate.textContent = `Expires on ${dateAux.toLocaleDateString('en-US', options)}`;
    } else if (keysExpirationDate) keysExpirationDate.textContent = '';
  }

  private initializePrivateSection(): void {
    const userNameField: HTMLInputElement = document.getElementById(
      'user-name-field'
    ) as HTMLInputElement;
    if (userNameField) userNameField.value = this.userManager.userName;

    if (!this.userManager.canChangePassword) {
      // TODO: Show something to tell the users that they can't change the password since their logged in using a
      // provider that doesn't allow it ("ie: Google Auth")

      // TODO: Remove the "Change password" Link
      return;
    }
    const changePasswordButton = document.getElementById('change-password') as HTMLElement;
    changePasswordButton.parentElement.addEventListener('click', () => {
      this.userManager.sendPasswordUpdateEmail();
    });
  }
}
